export const formatBoolYesNo = (value: boolean | null | undefined): string | null => {
  if (value == null) {
    return null;
  }
  return value ? 'Yes' : 'No';
};
